import { createSum } from '../lib/sumUtils';
import { paidId } from './paymentTypes';

export const typeKeys = {
  requestsPage: 'requestsPage',
  otherPages: 'otherPages',
};

export const types = new Set(Object.values(typeKeys));

export const stateKeys = {
  unset: 'unset',
  preliminary: 'preliminary',
  final: 'final',
  paid: 'paid',
};

export const methods = {
  getState: ({ invoice }) => {
    if (!invoice) {
      return stateKeys.unset;
    }

    const { isFinal, paymentState } = invoice;

    if (!isFinal) {
      return stateKeys.preliminary;
    }

    if (paymentState?.id === paidId) {
      return stateKeys.paid;
    }

    return stateKeys.final;
  },

  _createText: ({ prefix, sum }) => {
    const text = !sum ? 'не выставлен' : createSum({ sum });
    const content = [prefix, text].filter(Boolean).join(' ');

    return content[0].toUpperCase() + content.slice(1);
  },

  createContent: ({ type, sum }) => {
    const props = { sum };

    if (type === typeKeys.otherPages) {
      props.prefix = 'счет';
    }

    return methods._createText(props);
  },

  getTooltipTitle: (paymentType) =>
    paymentType?.name ? paymentType.name : 'Способ оплаты не определен',
};
